import axios from "axios";
import Config from "../utils/Config";

class AuthService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  async login(payload){
    try{
      const response = await axios.post(
        `${Config.apiUrl}/user/login`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Login successful!",
        data: response.data,
      };
    }catch(error){
      return {
        status: false,
        message: error.response?.data?.data?.reason || "Login failed!",
        data: null,
      };
    }
  }

  async register(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/register`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.message || "Registration successful!",
        data: response.data,
      };
    } catch (error) {
      let errorMessage = "An error occurred during registration";
      let validationErrors = null;

      if (error.response) {
        if (error.response.status === 422) {
          if (error.response.data?.errors) {
            validationErrors = error.response.data.errors;
            const errorFields = Object.keys(error.response.data.errors);
            if (errorFields.length === 1) {
              errorMessage = error.response.data.errors[errorFields[0]][0];
            } else {
              errorMessage = `${
                error.response.data.errors[errorFields[0]][0]
              } (and ${errorFields.length - 1} more error${
                errorFields.length > 2 ? "s" : ""
              })`;
            }
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = "Validation error. Please check your input.";
          }
        } else if (error.response.data?.data?.reason) {
          errorMessage = error.response.data.data.reason;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.status === 409) {
          errorMessage = "User already exists with this email or phone number.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error.message || "An unexpected error occurred";
      }

      return {
        status: false,
        message: errorMessage,
        validationErrors: validationErrors,
        data: null,
      };
    }
  }

  async verifyAccount(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/verify/account`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data.message || "Account verified successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason,
        data: null,
      };
    }
  }

  async resendVerificationCode(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/resend/verificationCode`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data.reason || "Code resent successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason,
        data: null,
      };
    }
  }

  async forgotPassword(phone_number) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/user/send/resetpassword/otp/${phone_number}`,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data.reason || "Code resent successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason,
        data: null,
      };
    }
  }

  async resetPassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/reset/password`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Password reset successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason || "Password reset failed!",
        data: null,
      };
    }
  }
}
const authService = new AuthService();
export default authService;
